import { Component, enableProdMode } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor() {
    if (environment.production) {
      enableProdMode();
    }
  }

  title = 'skylife-infinity-mentor';
}
